import { render, staticRenderFns } from "./RoofConstruction.vue?vue&type=template&id=7438cfad&"
import script from "./RoofConstruction.vue?vue&type=script&lang=ts&"
export * from "./RoofConstruction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports